import { ReactNode } from 'react';
import {
  Toolbar,
  ToolbarGroup,
  ToolbarItem,
  UtilityButton,
} from '@kinesis/bungle';
import { Breadcrumbs } from './breadcrumbs';

const InventoryToolbar = (props: InventoryToolbarProps) => {
  const {
    currentNav,
    currentNavLink,
    isEditor = false,
    children = null,
  } = props;

  return (
    <Toolbar>
      <ToolbarGroup>
        <Breadcrumbs currentNav={currentNav} currentNavLink={currentNavLink} />
      </ToolbarGroup>
      <ToolbarGroup>
        {children}
        {!isEditor && (
          <ToolbarItem>
            <UtilityButton disabled icon='eye-filled'>
              View only
            </UtilityButton>
          </ToolbarItem>
        )}
      </ToolbarGroup>
    </Toolbar>
  );
};

type InventoryToolbarProps = {
  currentNav?: string;
  currentNavLink?: string;
  isEditor?: boolean;
  children?: ReactNode;
};

export { InventoryToolbar };
